import api from '../../utils/api';
import history from '../../utils/history';
import { ShopifyActions } from '../reducers/shopify';
import { alertError } from './alert';
import { HOME_PATH } from '../../constants/pathRedirect';

const REQUIRED_QUERY = ['hmac', 'shop', 'timestamp'];

function isRequiredQueryParametersExist(params) {
  return REQUIRED_QUERY.every((key) => !!params.get(key));
}

async function getRedirectUrl(search) {
  return api.get(`/shopify/auth?${search}`);
}

export const validateAndGetGrantPageUrl = (search) => async (dispatch) => {
  dispatch({ type: ShopifyActions.loading, payload: { redirectUrl: true } });

  const params = new URLSearchParams(search);
  if (!isRequiredQueryParametersExist(params)) {
    return dispatch(alertError('Missing params in request, please try again.'));
  }

  try {
    const response = await getRedirectUrl(params);
    if (response.data && response.status === 200) {
      const { url: redirectUrl, connected } = response.data;
      if (connected) {
        history.push(HOME_PATH);
        return;
      }

      dispatch({
        type: ShopifyActions.redirectUrl,
        payload: {
          redirectUrl,
        },
      });
    } else {
      dispatch(alertError(`Couldn't get redirect url to Shopify`));
    }
  } catch (error) {
    dispatch(alertError(error));
  }
};

export function redirectToShopify({ url }) {
  window.location.replace(url);
}
